import React, { useState, useEffect } from "react";
import mammoth from "mammoth";
import { MathJax, MathJaxContext } from "better-react-mathjax";
import API_BASE_URL from "./config";
import Popup from "./Popup";
import toast, { Toaster } from "react-hot-toast";
// Custom Message Box Component
import { useSelector, useDispatch } from "react-redux";
import {
  setEditingQuestion,
  updateQuestion,
  addQuestionsFromFile,
} from "../components/questionBank/redux/questionBankSlice";
import {
  addQuestionThunk,
  editQuestionThunk,
  fetchQuestionsThunk,
} from "../components/questionBank/redux/questionBankThunk";
const MessageBox = ({ message, type, onClose }) => {
  if (!message) return null;

  const bgColor =
    type === "error"
      ? "bg-red-100 border-red-400 text-red-700"
      : "bg-green-100 border-green-400 text-green-700";
  const borderColor = type === "error" ? "border-red-500" : "border-green-500";

  return (
    <div
      className={`fixed top-4 left-1/2 -translate-x-1/2 p-4 rounded-lg shadow-lg z-50 ${bgColor} border ${borderColor} flex items-center justify-between`}
      style={{ minWidth: "300px" }}
    >
      <span>{message}</span>
      <button
        onClick={onClose}
        className="ml-4 text-lg font-bold leading-none hover:text-gray-900"
      >
        &times;
      </button>
    </div>
  );
};
const userStr = localStorage.getItem("user");
const userId = userStr ? JSON.parse(userStr).id : null;

// console.log(userId);
const AddQuestionForm = ({}) => {
  const dispatch = useDispatch();
  const selectedClassId = useSelector((state) => state.chapter.selectedClassId);
  const selectedSubjectId = useSelector(
    (state) => state.chapter.selectedSubjectId
  );
  const selectedChapterId = useSelector(
    (state) => state.chapter.selectedChapterId
  );
  const editData = useSelector((state) => state.questionBank.editingQuestion); // Adjust slice name if needed

  const [isProcessing, setIsProcessing] = useState(false);
  const [showModal, setShowModal] = useState(false);
  // Regular question states
  const [questionType, setQuestionType] = useState("");
  const [questionText, setQuestionText] = useState("");
  const [options, setOptions] = useState(["", "", "", ""]);
  const [difficultyLevel, setDifficultyLevel] = useState("");

  // Comprehension passage and questions
  const [comprehensionPassage, setComprehensionPassage] = useState("");
  const [comprehensionQuestions, setComprehensionQuestions] = useState([]);

  // Current comprehension sub-question being added
  const [compQuestionType, setCompQuestionType] = useState("");
  const [compQuestionText, setCompQuestionText] = useState("");
  const [compOptions, setCompOptions] = useState(["", "", "", ""]);

  // State for API fetched data
  const [fetchedQuestionTypes, setFetchedQuestionTypes] = useState([]);
  const [fetchedDifficultyLevels, setFetchedDifficultyLevels] = useState([]);
  const [loadingMasterData, setLoadingMasterData] = useState(true);
  const [errorMasterData, setErrorMasterData] = useState(null);

  // State for file upload
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [message, setMessage] = useState(null);
  const [messageType, setMessageType] = useState("info");

  // Image upload state: now stores the File object
  const [diagramImage, setDiagramImage] = useState(null);
  // State to store the URL of the uploaded image
  const [diagramImageUrl, setDiagramImageUrl] = useState("");
  const [imageUploading, setImageUploading] = useState(false);

  //Comprehension
  const addSubQuestion = () => {
    setComprehensionQuestions([...comprehensionQuestions, ""]);
  };

  //match the following
  const [matchPairsBulkInput, setMatchPairsBulkInput] = useState("");
  const [matchingPairs, setMatchingPairs] = useState([
    { column1_text: "", column2_text: "" }, // One initial empty pair
  ]);

  const handleMatchPairsBulkInput = (text) => {
    setMatchPairsBulkInput(text);

    const lines = text.split(/\r?\n/);

    const parsedPairs = lines
      .map((line) => {
        const [col1, col2] = line.split(",").map((s) => s.trim());
        if (col1 && col2) {
          return { column1_text: col1, column2_text: col2 };
        }
        return null;
      })
      .filter(Boolean);

    // 🔥 Update full state based on number of pairs
    setMatchingPairs(
      parsedPairs.length > 0
        ? parsedPairs
        : [{ column1_text: "", column2_text: "" }]
    );
  };


  function prepareForMathJax(text) {
    if (!text) return "";

    // e^(2x) → e^{2x}
    text = text.replace(
      /e\s*\^\s*\(\s*([^)]+)\s*\)/g,
      (_, exp) => `e^{${exp}}`
    );

    // base^power → base^{power}
    text = text.replace(
      /([a-zA-Z]+|\([^)]+\))\s*\^\s*(\d+)/g,
      (_, base, p) => `${base}^{${p}}`
    );

    return `${text})`;
  }

  // Update individual input fields
  const handleChange = (index, field, value) => {
    const updatedPairs = [...matchingPairs];
    updatedPairs[index][field] = value;
    setMatchingPairs(updatedPairs);
  };

  // Add new empty matching pair
  const addNewPair = () => {
    setMatchingPairs([
      ...matchingPairs,
      { column1_text: "", column2_text: "" },
    ]);
  };

  const removeSubQuestion = (index) => {
    const updated = [...comprehensionQuestions];
    updated.splice(index, 1);
    setComprehensionQuestions(updated);
  };

  const handleSubQuestionChange = (index, value) => {
    const updated = [...comprehensionQuestions];
    updated[index] = value;
    setComprehensionQuestions(updated);
  };

  const resetForm = () => {
    // Clear regular question fields
    setMatchingPairs([{ column1_text: "", column2_text: "" }]);
    setQuestionText("");
    setOptions(["", "", "", ""]);
    setQuestionType(
      fetchedQuestionTypes.length > 0 ? fetchedQuestionTypes[0].type_name : ""
    );
    setDifficultyLevel(
      fetchedDifficultyLevels.length > 0
        ? fetchedDifficultyLevels[0].difficulty_name
        : ""
    );

    // Clear comprehension fields
    setComprehensionPassage("");
    setComprehensionQuestions([]);
    setCompQuestionText("");
    setCompOptions(["", "", "", ""]);
    setCompQuestionType(
      fetchedQuestionTypes.length > 0 ? fetchedQuestionTypes[0].type_name : ""
    );

    // Clear image states
    setDiagramImage(null);
    setDiagramImageUrl(""); // Clear the URL as well
    setImageUploading(false);

    // Clear messages
    setMessage(null);
    setMessageType("info");
    dispatch(setEditingQuestion(null));
    setShowModal(false);
  };

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (file) {
      // ----- VALIDATION -----
      const ACCEPTED_TYPES = [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "image/webp",
      ];
      const MAX_SIZE = 1 * 1024 * 1024; // 1MB

      // File type check
      if (!ACCEPTED_TYPES.includes(file.type)) {
        setMessage("Only JPG, JPEG, PNG, or WEBP images are allowed.");
        setMessageType("error");
        return;
      }

      // Recommended size check (1MB)
      if (file.size > MAX_SIZE) {
        setMessage(
          "Recommended maximum size is 1MB. Please compress the image."
        );
        setMessageType("error");
        return;
      }

      setDiagramImage(file); // Store the file object
      setImageUploading(true);
      setMessage("Uploading image...");
      setMessageType("info");

      const formData = new FormData();
      formData.append("image", file); // 'image' should match the field name expected by your backend

      try {
        const response = await fetch(
          `https://web1024.docmaster.in:5007/upload`,
          {
            // New API endpoint for image upload
            method: "POST",
            body: formData,
          }
        );

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(
            errorData.message || `HTTP error! Status: ${response.status}`
          );
        }

        const result = await response.json();
        // Assuming the backend returns the URL of the uploaded image
        setDiagramImageUrl(result.uploaded);
        setMessage("Image uploaded successfully!");
        setMessageType("success");
      } catch (err) {
        console.error("Error uploading image:", err);
        setMessage(`Failed to upload image: ${err.message}`);
        setMessageType("error");
        setDiagramImage(null); // Clear the image if upload fails
        setDiagramImageUrl("");
      } finally {
        setImageUploading(false);
      }
    }
  };

  useEffect(() => {
    if (editData) {
      console.log("Edit data", editData);
      setQuestionType(editData.type_name || "");
      setQuestionText(editData.question_text || "");
      setOptions(
        editData.options && editData.options.length > 0
          ? editData.options.map((opt) => opt.text)
          : ["", "", "", ""]
      );
      if (editData.matching_options && editData.matching_options.length > 0) {
        setMatchingPairs(
          editData.matching_options.map((pair) => ({
            column1_text: pair.column1_text,
            column2_text: pair.column2_text,
          }))
        );
      }
      setDifficultyLevel(editData.difficulty_name || "");
      setComprehensionPassage(editData.passage_text || "");
      setComprehensionQuestions(editData.subQuestions || []);
      // When editing, if editData has images, set the URL
      if (editData.images && editData.images.length > 0) {
        setDiagramImageUrl(editData.images[0].image_url); // Assuming one image per question for now
      } else {
        setDiagramImageUrl("");
      }
      setShowModal(true);
    } else {
      resetForm(); // <- Call this to clean form if editData is null
    }
  }, [editData]);

  // Effect to fetch master data (question types, difficulty levels)
  useEffect(() => {
    const fetchMasterData = async () => {
      try {
        // Actual API calls to fetch question types
        const qTypesResponse = await fetch(
          `${API_BASE_URL}/subjects/question-types`
        );
        const qTypes = await qTypesResponse.json();

        // Actual API calls to fetch difficulty levels
        const dLevelsResponse = await fetch(
          `${API_BASE_URL}/subjects/difficulty-levels`
        );
        const dLevels = await dLevelsResponse.json();

        // Update state with fetched question types
        setFetchedQuestionTypes(qTypes);
        if (qTypes.length > 0) {
          setQuestionType(qTypes[0].type_name);
          setCompQuestionType(qTypes[0].type_name);
        }

        // Update state with fetched difficulty levels
        setFetchedDifficultyLevels(dLevels);
        if (dLevels.length > 0) {
          setDifficultyLevel(dLevels[0].difficulty_name);
        }
      } catch (error) {
        console.error("Error fetching master data:", error);
        setErrorMasterData(`Failed to load master data: ${error.message}`);
      } finally {
        setLoadingMasterData(false);
      }
    };

    fetchMasterData();
  }, []);
  // Helper to process options (mark correct with '*')
  const processOptions = (rawOptions) => {
    return rawOptions
      .filter((opt) => opt.trim() !== "")
      .map((opt) => {
        const isCorrect = opt.startsWith("*");
        const text = isCorrect ? opt.substring(1).trim() : opt.trim();
        return { text, is_correct: isCorrect };
      });
  };

  // Helper to get type ID from type name
  const getQuestionTypeId = (typeName) => {
    const type = fetchedQuestionTypes.find((q) => q.type_name === typeName);
    return type ? type.type_id : null;
  };

  // Helper to get difficulty ID from level name
  const getDifficultyId = (levelName) => {
    const difficulty = fetchedDifficultyLevels.find(
      (d) => d.difficulty_name === levelName
    );
    return difficulty ? difficulty.difficulty_id : null;
  };

  // Handlers for input changes
  const handleOptionChange = (index, value) => {
    const newOptions = [...options];
    newOptions[index] = value;
    setOptions(newOptions);
  };

  const handleCompOptionChange = (index, value) => {
    const updated = [...compOptions];
    updated[index] = value;
    setCompOptions(updated);
  };

  // Add sub-question for comprehension
  const handleAddCompQuestion = () => {
    if (compQuestionText.trim() === "") {
      setMessage("Please enter sub-question text.");
      setMessageType("error");
      return;
    }

    const processedCompOptions = processOptions(compOptions);
    if (
      (compQuestionType === "Multiple Choice Questions" ||
        compQuestionType === "Multiple Choice Multiple Correct" ||
        compQuestionType === "बहुविकल्पीय प्रश्न") &&
      processedCompOptions.length === 0
    ) {
      setMessage(
        "Multiple choice sub-question must have at least one valid option."
      );
      setMessageType("error");
      return;
    }

    const newCompQ = {
      id: Date.now(), // Client-side ID for list rendering
      type: compQuestionType,
      question: compQuestionText.trim(),
      options:
        compQuestionType === "Multiple Choice Questions" ||
        compQuestionType === "Multiple Choice Multiple Correct" ||
        compQuestionType === "बहुविकल्पीय प्रश्न"
          ? processedCompOptions
          : [],
      marks: 1, // Default marks for sub-questions
    };

    setComprehensionQuestions((prev) => [...prev, newCompQ]);
    setCompQuestionText("");
    setCompOptions(["", "", "", ""]);
    setCompQuestionType(
      fetchedQuestionTypes.length > 0 ? fetchedQuestionTypes[0].type_name : ""
    );
    setMessage("Sub-question added successfully!");
    setMessageType("info");
  };

  // Handle form submission for single/comprehension questions
  const handleSubmit = async (e) => {
    e.preventDefault();

    setMessage("");
    setMessageType("");

    const selectedQuestionTypeId = getQuestionTypeId(questionType);
    const selectedDifficultyId = getDifficultyId(difficultyLevel);

    if (!selectedQuestionTypeId || !selectedDifficultyId) {
      setMessage("Please select valid Question Type and Difficulty Level.");
      setMessageType("error");
      return;
    }

    if (!selectedClassId || !selectedSubjectId || !selectedChapterId) {
      setMessage("Please select Class, Subject, and Chapter.");
      setMessageType("error");
      return;
    }

    const payloadBase = {
      questionType: selectedQuestionTypeId,
      difficulty_id: selectedDifficultyId,
      created_by: userId,
      class_id: parseInt(selectedClassId),
      subject_id: parseInt(selectedSubjectId),
      chapter_id: parseInt(selectedChapterId),
      images: diagramImageUrl ? [diagramImageUrl] : [],
    };

    let finalPayload;
    const toastId = toast.loading("Processing...");
    if (questionType === "Comprehension Parent") {
      if (!comprehensionPassage.trim() || comprehensionQuestions.length === 0) {
        setMessage("Enter passage and at least one sub-question.");
        setMessageType("error");
        return;
      }

      finalPayload = {
        ...payloadBase,
        question_id: editData?.question_id,
        question_text: questionText.trim(),
        passage_text: comprehensionPassage.trim(),
        group_stat: "parent",
        marks: 0,
        subQuestions: comprehensionQuestions.map((q) => ({
          question_text: q.question,
          questionType: getQuestionTypeId(q.type),
          options: q.options,
          difficulty_id: selectedDifficultyId,
          marks: q.marks || 1,
          group_stat: "child",
          link_id: null,
        })),
      };
    } else if (questionType === "Comprehension") {
      finalPayload = {
        ...payloadBase,
        question_id: editData?.question_id,
        question_text: "",
        passage_text: comprehensionPassage.trim(),
        group_stat: null,
        marks: 0,
        subQuestions: comprehensionQuestions.map((q) => ({
          question_text: typeof q === "string" ? q : q.question_text,
          questionType: getQuestionTypeId("Short Answer"),
          options: [],
          difficulty_id: selectedDifficultyId,
          marks: 1,
          group_stat: "child",
          link_id: null,
        })),
      };
    } else if (
      questionType === "Match the Following" ||
      questionType === "मिलान करे"
    ) {
      const validPairs = matchingPairs.filter(
        (pair) => pair.column1_text.trim() && pair.column2_text.trim()
      );
      if (validPairs.length === 0) {
        setMessage("Please add valid matching pairs.");
        setMessageType("error");
        return;
      }

      finalPayload = {
        ...payloadBase,
        question_id: editData?.question_id,
        question_text: questionText.trim(),
        questionType: 16,
        matching_options: validPairs.map((pair, idx) => ({
          column1_text: pair.column1_text.trim(),
          column2_text: pair.column2_text.trim(),
          match_sort_order: idx + 1,
        })),
      };
    } else {
      const processedOpts = processOptions(options);
      if (
        (questionType === "Multiple Choice Questions" ||
          questionType === "Multiple Choice Multiple Correct" ||
          questionType === "बहुविकल्पीय प्रश्न") &&
        processedOpts.length === 0
      ) {
        setMessage("Add at least one valid option.");
        setMessageType("error");
        return;
      }

      finalPayload = {
        ...payloadBase,
        question_id: editData?.question_id,
        question_text: questionText.trim(),
        options: processedOpts,
        marks: 1,
        passage_text: null,
        group_stat: null,
        link_id: null,
      };
    }

    try {
      setIsProcessing(true);
      if (editData?.question_id) {
        await dispatch(
          editQuestionThunk({
            questionPayload: finalPayload,
            classId: selectedClassId,
            subjectId: selectedSubjectId,
            chapterId: selectedChapterId,
            userId: userId,
          })
        ).unwrap();
        dispatch(setEditingQuestion(null)); // optional
        dispatch(
          fetchQuestionsThunk({
            classId: selectedClassId,
            subjectId: selectedSubjectId,
            chapterId: selectedChapterId,
          })
        );
        alert("Updated Succesfully");
        setMessage("Question updated successfully!");
        setMessageType("success");
      } else {
        //debugger;
        await dispatch(
          addQuestionThunk({
            questionData: finalPayload,
            classId: selectedClassId,
            subjectId: selectedSubjectId,
            chapterId: selectedChapterId,
          })
        ).unwrap();
        dispatch(
          fetchQuestionsThunk({
            classId: selectedClassId,
            subjectId: selectedSubjectId,
            chapterId: selectedChapterId,
          })
        );
        setMessage("Question added successfully!");
        setMessageType("success");
      }

      setMessageType("success");
      resetForm();
    } catch (err) {
      console.error("Error:", err);
      setMessage(err || "Failed to process the question.");
      setMessageType("error");
    } finally {
       toast.success("✅  successful!", { id: toastId });
      setIsProcessing(false);
    }
  };

  // Handler for file selection
  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
    setMessage(null); // Clear previous messages
  };

  // Parser for HTML content
  const parseWordHtmlForQuestions = (htmlContent) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlContent, "text/html");
    const questions = [];

    const questionTables = doc.querySelectorAll(
      'table[style*="width: 100.013%; border-color: #ffffff; border-style: hidden;"]'
    );

    questionTables.forEach((table) => {
      const questionTextElement = table.querySelector("td:first-child span");
      if (questionTextElement && questionTextElement.innerText.includes("Q.")) {
        const questionText = questionTextElement.innerText
          .replace("Q.", "")
          .trim();
        const currentOptions = [];

        // Look for the <p> element immediately following this table
        let nextSibling = table.nextElementSibling;
        while (
          nextSibling &&
          nextSibling.tagName === "P" &&
          nextSibling.style.paddingLeft === "40px"
        ) {
          const rawOptionsText = nextSibling.innerHTML;
          const optionLines = rawOptionsText.split(/<br\s*\/?>/i);

          optionLines.forEach((line, idx) => {
            const cleanLine = line.replace(/<span[^>]*>|<\/span>/g, "").trim();
            if (cleanLine) {
              const optionMatch = cleanLine.match(/^([a-d]\)\s*)(.*)/i);
              const optionText = optionMatch
                ? optionMatch[2].trim()
                : cleanLine;
              currentOptions.push({ text: optionText, is_correct: idx === 0 });
            }
          });
          nextSibling = nextSibling.nextElementSibling;
        }

        questions.push({
          question_text: questionText,
          options: currentOptions,
          questionType:
            getQuestionTypeId("Multiple Choice Questions") ||
            getQuestionTypeId("बहुविकल्पीय प्रश्न"),
          difficulty_id: getDifficultyId(difficultyLevel),
          marks: 1,
          created_by: userId,
          passage_text: null,
          group_stat: null,
          link_id: null,
          images: [],
        });
      }
    });
    return questions;
  };

  // Parser for raw text content
  const parseRawTextForQuestions = (rawTextContent) => {
    const questions = [];
    const questionBlocks = rawTextContent
      .split(/\s*Q\.\s*/)
      .filter((block) => block.trim() !== "");

    questionBlocks.forEach((block) => {
      const lines = block
        .split("\n")
        .map((line) => line.trim())
        .filter((line) => line !== "");
      if (lines.length === 0) return;

      const questionText = lines[0];
      const currentOptions = [];

      for (let i = 1; i < lines.length; i++) {
        const line = lines[i];
        const optionMatch = line.match(/^([a-d])\)\s*(.*)/i);
        if (optionMatch) {
          const optionText = optionMatch[2].trim();
          currentOptions.push({
            text: optionText,
            is_correct: optionMatch[1].toLowerCase() === "a",
          });
        } else {
          break;
        }
      }

      if (questionText) {
        questions.push({
          question_text: questionText,
          options: currentOptions,
          questionType:
            getQuestionTypeId("Multiple Choice Questions") ||
            getQuestionTypeId("बहुविकल्पीय प्रश्न"),
          difficulty_id: getDifficultyId(difficultyLevel),
          marks: 1,
          created_by: userId,
          passage_text: null,
          group_stat: null,
          link_id: null,
          images: [],
        });
      }
    });
    return questions;
  };

  // Handler for uploading the file
  // const handleUploadFile = () => {
  //   if (!selectedFile) {
  //     setMessage("Please select a file to upload.");
  //     setMessageType("error");
  //     return;
  //   }

  //   setUploading(true);
  //   setMessage("Processing file...");
  //   setMessageType("info");

  //   const reader = new FileReader();

  //   reader.onload = async (e) => {
  //     try {
  //       let parsedQuestions = [];

  //       if (
  //         selectedFile.name.endsWith(".html") ||
  //         selectedFile.name.endsWith(".htm")
  //       ) {
  //         const htmlContent = e.target.result;
  //         parsedQuestions = parseWordHtmlForQuestions(htmlContent);
  //       } else if (
  //         selectedFile.name.endsWith(".docx") ||
  //         selectedFile.name.endsWith(".doc")
  //       ) {
  //         const arrayBuffer = e.target.result;
  //         const result = await mammoth.extractRawText({ arrayBuffer });
  //         parsedQuestions = parseRawTextForQuestions(result.value);
  //       } else {
  //         setMessage(
  //           "Unsupported file type. Please upload .html, .htm, .docx, or .doc files."
  //         );
  //         setMessageType("error");
  //         setUploading(false);
  //         return;
  //       }

  //       if (parsedQuestions.length > 0) {
  //         console.log("Parsed Questions:", parsedQuestions);
  //         if (onAddQuestionsFromFile) {
  //           onAddQuestionsFromFile(parsedQuestions);
  //           setMessage(
  //             `Successfully added ${parsedQuestions.length} questions from file!`
  //           );
  //           setMessageType("success");
  //           setSelectedFile(null);
  //         } else {
  //           setMessage(
  //             "onAddQuestionsFromFile prop is not provided to handle parsed questions."
  //           );
  //           setMessageType("error");
  //         }
  //       } else {
  //         setMessage(
  //           "No questions could be extracted from the file. Please ensure it has the expected format."
  //         );
  //         setMessageType("error");
  //       }
  //     } catch (error) {
  //       console.error("Error parsing file:", error);
  //       setMessage(
  //         `Error parsing file: ${error.message}. Please ensure it's a valid file with the expected structure.`
  //       );
  //       setMessageType("error");
  //     } finally {
  //       setUploading(false);
  //     }
  //   };

  //   reader.onerror = () => {
  //     setMessage("Failed to read file.");
  //     setMessageType("error");
  //     setUploading(false);
  //   };

  //   if (
  //     selectedFile.name.endsWith(".docx") ||
  //     selectedFile.name.endsWith(".doc")
  //   ) {
  //     reader.readAsArrayBuffer(selectedFile);
  //   } else {
  //     reader.readAsText(selectedFile);
  //   }
  // };

  if (loadingMasterData) {
    return (
      <div className="text-center p-8 text-lg">
        Loading question types and difficulty levels...
      </div>
    );
  }

  if (errorMasterData) {
    return (
      <div className="text-center p-8 text-lg text-red-600">
        Error: {errorMasterData}
      </div>
    );
  }

  return (
    <div className=" mx-auto font-sans ">
      <MessageBox
        message={message}
        type={messageType}
        onClose={() => setMessage(null)}
      />
      <Toaster position="top-center" reverseOrder={false} />
      <div className=" text-end w-100 text-end">
        <button
          onClick={() => setShowModal(true)}
          className="btn m-0 btn-primary"
        >
          {editData ? "Update Question" : "Add Question"}
        </button>
      </div>
      {/* Manual Question Entry Form */}
      {showModal && (
        <Popup
          title="Add New Question"
          onClose={() => {
            setShowModal(false);
            resetForm();
          }}
        >
          <form
            onSubmit={handleSubmit}
            className="mb-1 p-3 w-100 border border-gray-200 rounded-lg bg-gray-50 shadow-md"
          >
            {/* <h2 className="text-2xl font-bold mb-6 text-gray-800">Add New Question</h2> */}
            <div className="row mb-3">
              <label
                htmlFor="questionType"
                className="block col-sm-3 col-form-label text-gray-700 font-bold "
              >
                Question Type:
              </label>
              <div className="col-sm-9">
                <select
                  id="questionType"
                  value={questionType}
                  onChange={(e) => setQuestionType(e.target.value)}
                  className="w-full p-2 form-control border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                >
                  {fetchedQuestionTypes.map((type) => (
                    <option key={type.type_id} value={type.type_name}>
                      {type.type_name.replace(/([A-Z])/g, " $1").trim()}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="row mb-1">
              <label
                htmlFor="difficultyLevel"
                className="block col-sm-3 col-form-label text-gray-700 font-bold "
              >
                Difficulty Level:
              </label>
              <div className="col-sm-9">
                <select
                  id="difficultyLevel"
                  value={difficultyLevel}
                  onChange={(e) => setDifficultyLevel(e.target.value)}
                  className="w-full p-2 border border-gray-300 form-control rounded-md focus:ring-blue-500 focus:border-blue-500"
                >
                  {fetchedDifficultyLevels.map((level) => (
                    <option
                      key={level.difficulty_id}
                      value={level.difficulty_name}
                    >
                      {level.difficulty_name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            {/* Image Upload Input */}
            <div className="row mb-1">
              <label
                htmlFor="diagramImage"
                className="block col-sm-3 col-form-label text-gray-700 font-bold "
              >
                Diagram Image:
              </label>
              <div className="col-sm-9">
                <input
                  id="diagramImage"
                  type="file"
                  accept="image/*"
                  onChange={handleImageUpload}
                  className="w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                  disabled={imageUploading} // Disable while uploading
                />
                {diagramImageUrl && (
                  <div className="mt-1">
                    <p className="text-sm text-gray-500">Image Preview:</p>
                    <img
                      src={diagramImageUrl}
                      alt="Diagram Preview"
                      className="max-w-xs h-auto rounded-md border"
                    />
                  </div>
                )}
                {imageUploading && (
                  <p className="text-sm text-blue-600">Uploading image...</p>
                )}
              </div>
            </div>
            {questionType === "Comprehension Parent" ? (
              <>
                <div className="row mb-1">
                  <label
                    htmlFor="comprehensionTitle"
                    className="block text-gray-700 col-sm-12 mb-0 col-form-label font-bold "
                  >
                    Comprehension Title/Summary (Optional):
                  </label>
                  <div className="col-sm-12">
                    <input
                      id="comprehensionTitle"
                      type="text"
                      value={questionText}
                      onChange={(e) => setQuestionText(e.target.value)}
                      placeholder="Enter a title or summary for the passage"
                      className="w-full p-2 border form-control border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                    />
                  </div>
                </div>
                <div className="row mb-1">
                  <label
                    htmlFor="comprehensionPassage"
                    className="block text-gray-700 col-sm-12 col-form-label font-bold "
                  >
                    Add Comprehension Passage:
                  </label>
                  <div className="col-sm-12">
                    <textarea
                      id="comprehensionPassage"
                      value={comprehensionPassage}
                      onChange={(e) => setComprehensionPassage(e.target.value)}
                      placeholder="Enter comprehension passage"
                      rows={6}
                      className="w-full col-sm-12 p-2 border border-gray-300 rounded-md resize-y focus:ring-blue-500 focus:border-blue-500"
                    />
                  </div>
                </div>
                <hr className="my-8 border-t-2 border-dashed border-gray-300" />
                <h4 className="text-lg text-center font-semibold mb-1 text-gray-700">
                  Add Sub-Questions for Comprehension
                </h4>
                <div className="row mb-3">
                  <label
                    htmlFor="compQuestionType"
                    className="block col-sm-4 col-form-label text-gray-700 font-bold "
                  >
                    Sub-Question Type:
                  </label>
                  <div className="col-sm-8">
                    <select
                      id="compQuestionType"
                      value={compQuestionType}
                      onChange={(e) => setCompQuestionType(e.target.value)}
                      className="w-full p-2 form-control border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                    >
                      {fetchedQuestionTypes.map((type) => (
                        <option key={type.type_id} value={type.type_name}>
                          {type.type_name.replace(/([A-Z])/g, " $1").trim()}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="row mb-1">
                  <label
                    htmlFor="compQuestionText"
                    className="block col-sm-12 col-form-label text-gray-700 font-bold "
                  >
                    Sub-Question Text:
                  </label>
                  <div className="col-sm-12">
                    <input
                      id="compQuestionText"
                      type="text"
                      value={compQuestionText}
                      onChange={(e) => setCompQuestionText(e.target.value)}
                      placeholder="Enter sub-question text"
                      className="w-full p-2 border form-control border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                    />
                  </div>
                </div>
                {(compQuestionType === "Multiple Choice Questions" ||
                  compQuestionType === "Multiple Choice Multiple Correct" ||
                  compQuestionType === "बहुविकल्पीय प्रश्न") && (
                  <div className="row mb-3">
                    <label className="block text-gray-700 col-sm-12 col-form-label font-bold ">
                      Options (Prefix correct with *):
                    </label>
                    {compOptions.map((option, index) => (
                      <div className="col-sm-12 mb-2" key={index}>
                        <input
                          type="text"
                          value={option}
                          onChange={(e) =>
                            handleCompOptionChange(index, e.target.value)
                          }
                          placeholder={`Option ${index + 1}`}
                          className="w-full p-2 border form-control border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                        />
                      </div>
                    ))}
                  </div>
                )}
                <button
                  type="button"
                  onClick={handleAddCompQuestion}
                  className="px-4 py-2 bg-green-500 text-white rounded-md hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
                >
                  Add Sub-Question
                </button>

                <div className="mt-6">
                  <h5 className="text-md font-semibold mb-2">
                    Current Sub-Questions:
                  </h5>
                  {comprehensionQuestions.length === 0 ? (
                    <p className="text-gray-500">No sub-questions added yet.</p>
                  ) : (
                    <ul className="list-disc pl-5">
                      {comprehensionQuestions.map((subQ, index) => (
                        <li key={subQ.id} className="text-gray-700 mb-1">
                          <strong>
                            {index + 1}. (
                            {subQ.type.replace(/([A-Z])/g, " $1").trim()}):
                          </strong>{" "}
                          {subQ.question}
                          {subQ.options.length > 0 && (
                            <ul className="list-circle pl-5 text-sm">
                              {subQ.options.map((opt, optIndex) => (
                                <li
                                  key={optIndex}
                                  className={
                                    opt.is_correct
                                      ? "font-semibold text-green-700"
                                      : ""
                                  }
                                >
                                  {opt.text} {opt.is_correct && "(Correct)"}
                                </li>
                              ))}
                            </ul>
                          )}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </>
            ) : questionType === "Comprehension" ? (
              <>
                {/* Comprehension Passage */}
                <div className="row mb-3">
                  <label
                    htmlFor="comprehensionPassage"
                    className="block col-sm-12 col-form-label text-gray-700 font-bold"
                  >
                    Comprehension Passage:
                  </label>
                  <div className="col-sm-12">
                    <textarea
                      id="comprehensionPassage"
                      value={comprehensionPassage}
                      onChange={(e) => setComprehensionPassage(e.target.value)}
                      placeholder="Enter comprehension passage"
                      rows={6}
                      className="w-full p-2 border form-control border-gray-300 rounded-md resize-y focus:ring-blue-500 focus:border-blue-500"
                    />
                  </div>
                </div>

                {/* Dynamic Sub-Questions */}
                <div className="row mb-3">
                  <label className="block col-sm-12 col-form-label text-gray-700 font-bold">
                    Sub-Questions:
                  </label>
                  {comprehensionQuestions.map((subQ, index) => (
                    <div
                      key={index}
                      className="col-sm-12 mb-2 flex items-center gap-2"
                    >
                      <input
                        type="text"
                        value={subQ.question_text}
                        onChange={(e) =>
                          handleSubQuestionChange(index, e.target.value)
                        }
                        placeholder={`Sub-question ${index + 1}`}
                        className="w-full p-2 border form-control border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                      />
                      <button
                        type="button"
                        onClick={() => removeSubQuestion(index)}
                        className="px-2 py-1 bg-red-500 text-white rounded hover:bg-red-600"
                      >
                        ✕
                      </button>
                    </div>
                  ))}

                  <button
                    type="button"
                    onClick={addSubQuestion}
                    className="mt-2 px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600"
                  >
                    + Add Sub-Question
                  </button>
                </div>
              </>
            ) : questionType === "Match the Following" ||
              questionType === "मिलान करे" ? (
              <>
                <div className="p-4 max-w-xl mx-auto">
                  <div className="mb-4">
                    <label className="block text-gray-700 font-semibold mb-1">
                      Question Text:
                    </label>
                    <input
                      type="text"
                      value={questionText}
                      onChange={(e) => setQuestionText(e.target.value)}
                      placeholder="Enter your question..."
                      className="w-full p-2 border border-gray-300 rounded focus:ring-blue-500 focus:border-blue-500"
                    />
                    &nbsp;
                    <textarea
                      value={matchPairsBulkInput}
                      onChange={(e) =>
                        handleMatchPairsBulkInput(e.target.value)
                      }
                      placeholder="Paste values like: 
                      apple, fruit 
                      bike, vehicle"
                      rows={6}
                      className="mt-2 w-full p-2 border form-control border-gray-300 rounded-md resize-y focus:ring-blue-500 focus:border-blue-500"
                    />
                  </div>

                  {matchingPairs.map((pair, index) => (
                    <div key={index} className="flex gap-4 mb-2">
                      <input
                        type="text"
                        placeholder={`Column A - ${index + 1}`}
                        value={pair.column1_text}
                        onChange={(e) =>
                          handleChange(index, "column1_text", e.target.value)
                        }
                        className="w-1/2 p-2 border border-gray-300 rounded"
                      />
                      <input
                        type="text"
                        placeholder={`Column B - ${index + 1}`}
                        value={pair.column2_text}
                        onChange={(e) =>
                          handleChange(index, "column2_text", e.target.value)
                        }
                        className="w-1/2 p-2 border border-gray-300 rounded"
                      />
                    </div>
                  ))}

                  <button
                    type="button"
                    onClick={addNewPair}
                    className="mt-2 px-4 py-2 bg-blue-600 text-white rounded"
                  >
                    ➕ Add Pair
                  </button>
                </div>
              </>
            ) : (
              <>
                <div className="row mb-3">
                  <label
                    htmlFor="questionText"
                    className="block col-sm-12 col-form-label text-gray-700 font-bold "
                  >
                    Question Text:
                  </label>
                  <div className="col-sm-12">
                    <textarea
                      id="questionText"
                      value={questionText}
                      onChange={(e) => setQuestionText(e.target.value)}
                      placeholder="Enter question text"
                      rows={4}
                      className="w-full p-2 border form-control border-gray-300 rounded-md resize-y focus:ring-blue-500 focus:border-blue-500"
                    />
                  </div>
                  {(questionText.includes("$") ||
                    questionText.includes("\\(") ||
                    questionText.includes("\\[")) && (
                    <MathJaxContext>
                      <div className="mt-3 p-3 border rounded bg-gray-100">
                        <strong>Mathematic Type Preview:</strong>

                        {questionText.trim() ? (
                          <MathJax dynamic>
                            <span>{prepareForMathJax(questionText)}</span>
                          </MathJax>
                        ) : (
                          <div>No preview</div>
                        )}
                      </div>
                    </MathJaxContext>
                  )}
                </div>
                {(questionType === "Multiple Choice Questions" ||
                  questionType === "Multiple Choice Multiple Correct" ||
                  questionType === "बहुविकल्पीय प्रश्न") && (
                  <div className="row mb-3">
                    <label className="block col-sm-12 col-form-label text-gray-700 font-bold ">
                      Options (Prefix correct with *):
                    </label>
                    {options.map((option, index) => (
                      <div className="col-sm-12 mb-2" key={index}>
                        <input
                          type="text"
                          value={option}
                          onChange={(e) =>
                            handleOptionChange(index, e.target.value)
                          }
                          placeholder={`Option ${index + 1}`}
                          className="w-full p-2 border form-control border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                        />
                      </div>
                    ))}
                  </div>
                )}
              </>
            )}
            <button
              type="submit"
              className="px-2 py-2 mt-2 mb-3 font-semibold rounded-md bg-blue-600 text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              {editData ? "Update Question" : "Add Question"}
            </button>
            <button
              type="button"
              onClick={resetForm}
              className="px-2 py-2 mt-2 mb-3 font-semibold rounded-md bg-gray-300 text-gray-800 hover:bg-gray-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
            >
              Cancel
            </button>
          </form>
          {/* File Upload Section (Optional - kept for context from original file) */}
          {/* <div className="p-4 border border-gray-200 rounded-lg bg-white shadow-md">
            <h2 className="text-xl font-bold mb-4 text-gray-800">Upload Questions from File</h2>
            <div className="mb-4">
              <input type="file" onChange={handleFileChange} className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-semibold file:bg-purple-50 file:text-purple-700 hover:file:bg-purple-100" />
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                <div className="bg-blue-50 p-4 rounded-md">
                    <h3 className="font-bold text-blue-700 mb-2">HTML File Requirements</h3>
                    <ul className="list-disc pl-5 text-sm">
                        <li>Exported from Microsoft Word as HTML</li>
                        <li>Questions start with "Q."</li>
                        <li>Options formatted as "a) Option text", "b) Option text", etc.</li>
                    </ul>
                </div>
                <div className="bg-purple-50 p-4 rounded-md">
                    <h3 className="font-bold text-purple-700 mb-2">Word File Requirements</h3>
                    <ul className="list-disc pl-5 text-sm">
                        <li>.docx or .doc format</li>
                        <li>Questions start with "Q."</li>
                        <li>Options on new lines starting with "a) ", "b) ", etc.</li>
                    </ul>
                </div>
            </div>
            <button
                onClick={handleUploadFile}
                disabled={!selectedFile || uploading}
                className={`px-6 py-3 font-semibold rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 transition duration-200 ease-in-out
                            ${!selectedFile || uploading ? 'bg-gray-400 cursor-not-allowed' : 'bg-purple-600 text-white hover:bg-purple-700 focus:ring-purple-500'}`}
            >
                {uploading ? 'Processing...' : 'Upload Questions'}
            </button>
        </div> */}
        </Popup>
      )}
    </div>
  );
};

export default AddQuestionForm;
